module.exports = __webpack_public_path__ + "img/milad.e5b1ac20.jpg";